// 引入api
import { fun_PostAction, fun_Download } from "@/api";
import CaLock from "@/components/common/calock";
import {
  fun_StampModule,
  fun_InsertStamp,
  fun_DeleteSelect,
  fun_Init
} from "@/utils/sealUtil";
export default {
  data: () => {
    return {
      // 弹窗状态
      dialogVisible: false,
      // 全局加载
      fullLoading: null,
      // pdf路径
      pdfUrl: null,
      // 文件路径
      noticePdfPath: null,
      // 盖章图片路径
      sealImg: null,
      // 图片类型
      signatureType: null,  
      // 签章类型
      type: null,  
      // 中标候选人主键
      winningCandidateId: null,
      // 操作类型
      controllerFlg: null,
      // 初始化参数
      StampModule: null,
      // 盖章弹框
      stampDialogVisible: false,
      // 盖章值
      stampName: null,
      // 盖章弹框下拉框参数：
      stampOptions:[
        {name: "企业章", value: "2"},
        {name: "法人章", value: "1"}
      ]
    };
  },
  props: {
    
  },
  // 注册组件
  components: {
    // ca弹窗
    CaLock
  },
  mounted() {
    // 给pdf.js加入全局删除方法
    fun_Init(this);
  },
  methods: {
    // 打开弹框时调用
    async fun_GetOpen() {  
      // 预览PDF
      this.fun_Look();
    },
    /**
     * 预览PDF
     */
    fun_Look(){
      // 获取id
      fun_Download("/downloadLocal?filePath=" + this.noticePdfPath).then(res => {
        // 存储this
        const data = new Blob([res.data], { type: "application/pdf" });
        // 预览PDF
        this.pdfUrl =
          "./static/pdf/web/viewer.html?file=" +
          encodeURIComponent(URL.createObjectURL(data));
      });
    },
    /**
     * 盖章
     */
    fun_InsertStamp(e){
      // 关闭弹框
      this.stampDialogVisible = false;
      // 开启弹窗
      this.$refs.caLock.dialogCalock = true;
      // 签名数据, 交易人名称和日期
      this.$refs.caLock.data = this.winningCandidateId;
      // 页面类型
      this.$refs.caLock.pageType = "seal";
      // 状态
      this.$refs.caLock.state = "tj";
    },
    /**
     * 保存或修改的方法
     * @author shuhua
     */
    fun_SaveOrUpdate(state, lockNo, digitalSignature, type, token) {
      // ca弹窗关闭
      this.$refs.caLock.dialogCalock = false;
      // 设置扫码类型
      this.type = type;
      // 请求
      fun_PostAction("/seal/getSealImg", {
        lockNo: lockNo, //锁编号
        type: type, // 扫码类型
        token: token, // 图片类型
        signatureType: this.signatureType, // 图片类型
      }).then(res => {
        // 设置签章图片
        this.sealImg = res.data.data;
        // 调用盖章
        this.fun_SetStamp();
        // 初始化加载
        fun_InsertStamp(this, this.sealImg);
        // 关闭loading
        this.loading = false;
      });
    },
    /**
     * 调用盖章
     */
    fun_SetStamp() {
      /**
       * @param file pdf文件
       * @param id 主键
       * @param sealImg 盖章图片base64
       */
      // 获取初始化参数
      this.StampModule = fun_StampModule(
        this,
        "",
        this.winningCandidateId,
        this.sealImg,
        this.noticePdfPath,
      );
    },
    /**
    * 删除盖章时75%没有偏移量的问题 需要将ifarme的名字和主键都改成 pdfviewer
    */
    fun_DeleteSelect() {
      fun_DeleteSelect();
    },
    /**
     * 提交方法 
     */
    fun_SealSubmit() {
      // 请求
      fun_PostAction("/winningNotice/sealWinNoticePdf", {
        id: this.winningCandidateId, // 中标候选人主键
        signatureType: this.signatureType, // 图片类型
      }).then(res => {
        // 解构res.data
        const {
          result,
          data,
          msg
        } = res.data;
        // 解析后台返回的结果集，判断是否成功
        if (result) {
          // 操作成功
          this.$message.success(msg);
        } else {
          // 如果页面验证失败
          if (data != null && data != "") {
            // 返回错误消息
            this.errRules = data;
            // 请求失败，弹出失败msg的消息提示
            this.$message.error("您输入的数据存在错误！");
          } else {
            // 请求失败，弹出失败msg的消息提示
            this.$message.error(msg);
          }
        }
        // 关闭loading
        this.loading = false;
      });
    },
    /**e
     * 盖章选择
     */
    fun_ChangeStampSelect(e){
      // 设置盖章类型
      this.signatureType = e;
    },
    /**
     * 调用盖章方法
     */
    fun_GetStamp(){
      // 打开弹框
      this.stampDialogVisible = true;
    },
    /**
     * 弹框盖章
     */
    fun_Stamp(){
      // 盖章
      this.fun_InsertStamp(this.signatureType);
    },
  }
};
